var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#FCC830"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4538 18.0439C13.4538 18.8974 12.762 19.5892 11.9086 19.5892C11.0551 19.5892 10.3633 18.8974 10.3633 18.0439C10.3633 17.1905 11.0551 16.4987 11.9086 16.4987C12.762 16.4987 13.4538 17.1905 13.4538 18.0439Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9086 19.1678C12.5292 19.1678 13.0324 18.6646 13.0324 18.0439C13.0324 17.4233 12.5292 16.9201 11.9086 16.9201C11.2879 16.9201 10.7847 17.4233 10.7847 18.0439C10.7847 18.6646 11.2879 19.1678 11.9086 19.1678ZM11.9086 19.5892C12.762 19.5892 13.4538 18.8974 13.4538 18.0439C13.4538 17.1905 12.762 16.4987 11.9086 16.4987C11.0551 16.4987 10.3633 17.1905 10.3633 18.0439C10.3633 18.8974 11.0551 19.5892 11.9086 19.5892Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.013 4.90909C12.7113 4.90909 13.2773 5.47514 13.2773 6.17341L13.2773 14.0754C13.2773 14.7737 12.7113 15.3397 12.013 15.3397C11.3148 15.3397 10.7487 14.7737 10.7487 14.0754L10.7487 6.17341C10.7487 5.47514 11.3148 4.90909 12.013 4.90909Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWarning);
export default __webpack_public_path__ + "static/media/ic_warning.6a138a66da8bf9a6a5c1b751a0cacad4.svg";
export { ForwardRef as ReactComponent };